import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { CreateEditPageMembershipMatchingRuleForm } from '../../../_lib/Form2';
import { useDelayed } from '../../../hooks/useDelayed';
import { useNavigate } from 'react-router';

type PageMembershipMatchingRuleSettingsEdit = Pick<
  CreateEditPageMembershipMatchingRuleForm,
  'form' | 'pageToRole' | 'areaSiteMapUrl'
>;

function PageMembershipMatchingRuleSettingsEdit({
  form,
  pageToRole,
  areaSiteMapUrl,
}: PageMembershipMatchingRuleSettingsEdit) {
  const navigate = useNavigate();
  const delayedPageRefresh = useDelayed(() => {
    navigate(0);
  });

  return (
    <CreateEditPageMembershipMatchingRuleForm
      form={form}
      pageToRole={pageToRole}
      areaSiteMapUrl={areaSiteMapUrl}
      onSuccess={delayedPageRefresh}
    />
  );
}
export const PageMembershipMatchingRuleSettingsEditView = asFetchableView(PageMembershipMatchingRuleSettingsEdit);
export type PageMembershipMatchingRuleSettingsEditView = ComponentProps<typeof PageMembershipMatchingRuleSettingsEdit>;
